//运营端api
import request from '../util/request'

// 使用密码登录
export function loginByPwd(data) {
  return request({
    url: 'op/oauth/token',
    method: 'post',
    data
  })
}

//将订单设置为已支付
export function setPaid(id) {
  return request({
    url: `op/orders/${id}/_set-paid`,
    method: 'put'
  })
}

//查询订单列表
export function getOrderList(params) {
  return request({
    url: 'op/orders',
    method: 'get',
    params
  })
}